import template from './was-this-useful-feedback-text.component.html';
var WasThisUsefulFeedbackTextComponentController = /** @class */ (function () {
    function WasThisUsefulFeedbackTextComponentController() {
    }
    WasThisUsefulFeedbackTextComponentController.prototype.$onInit = function () {
        this.feedbackTextIsolated = this.feedbackText || '';
    };
    WasThisUsefulFeedbackTextComponentController.prototype.$onChanges = function () {
        if (this.feedbackText === this.feedbackTextIsolated) {
            return;
        }
        this.feedbackTextIsolated = this.feedbackText;
    };
    WasThisUsefulFeedbackTextComponentController.$inject = [];
    return WasThisUsefulFeedbackTextComponentController;
}());
export var WasThisUsefulFeedbackTextComponent = {
    bindings: {
        feedbackText: '<',
        feedbackTextLabel: '<',
        onFeedbackTextChange: '&?',
    },
    controller: WasThisUsefulFeedbackTextComponentController,
    template: template,
};
